// removed by extract-text-webpack-plugin
module.exports = {"SplashHolder":"SplashScreen__SplashHolder__3D303","SplashLogoHolder":"SplashScreen__SplashLogoHolder__1x3Yy","SplashText":"SplashScreen__SplashText__3ly2o"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SplashScreen/SplashScreen.css
// module id = 515
// module chunks = 0